export const formatAmount = (value: number): string => {
  if (!value || value === 0) return "0";

  if (value >= 10000000) {
    return `${(value / 10000000)
      .toFixed(2)
      .replace(/\.00$/, "")}Cr`;
  }

  if (value >= 100000) {
    return `${(value / 100000)
      .toFixed(2)
      .replace(/\.00$/, "")}L`;
  }

  if (value >= 1000) {
    return `${(value / 1000)
      .toFixed(2)
      .replace(/\.00$/, "")}K`;
  }

  return value.toString();
};
